export const contactBG = {
  "mustHaveChar": "Трябва да съдържа поне два символа",
  "less255": "Трябва да е по-кратко от 255 символа",
  "required": "Задължително",
  "invalidEmail": "Невалиден имейл",
  "invalidPhone": "Невалиден телефонен номер",
  "textareaMax": "Трябва да е по-кратко от 1000 символа",
  "contactForm": "Контактна форма",
  "firstName": "Име",
  "lastName": "Фамилия",
  "phone": "Телефон",
  "email": "Имейл",
  "text": "Съобщение",
  "buttonForm": "Изпрати",
  "emailSent": "Имейлът е изпратен!",
  "emailSentMessage": "Успешно изпратихте вашия имейл!",
  "emailError": "Грешка при изпращане!",
  "emailErrorMessage": "Вашият имейл не беше изпратен!"
}